//
//
//
//
//
//
//
//
//
//

// 网络错误组件
export default {
  name: 'NetworkError',
  data: function data() {
    return {
      title: '网络错误组件'
    };
  },
  props: {},
  created: function created() {},
  destroyed: function destroyed() {},
  methods: {
    refresh: function refresh() {
      this.$emit('refreshEvent');
    }
  }
};